export default __webpack_public_path__ + "static/calendars-unite-4ce25097940a9b9d0cbcf2c3e5ea1daf.svg";